export default __webpack_public_path__ + "static/media/ca.0a47e0d3.svg";